<div class="hora-container mat-elevation-z2">
    <div class="header">
        <span class="titulo">
            <mat-icon color="primary" class="icon-time">access_time</mat-icon>
            <span>{{ data?.titulo || 'Excepción de Tickeo' }}</span>
        </span>
    </div>

    <div class="form-content">
        <span class="info-name" *ngIf="esAprobador">
            <strong>
                {{ capitalizeFirst(solicitud?.id_registro?.id_funcionario?.nombre || '') }}
                {{ capitalizeFirst(solicitud?.id_registro?.id_funcionario?.paterno || '') }}
                {{ capitalizeFirst(solicitud?.id_registro?.id_funcionario?.materno || '') }}
                {{ capitalizeFirst(solicitud?.id_registro?.id_funcionario?.casada || '') }}
            </strong>
        </span>

        <!-- Mantiene el mensaje original para los demás formularios -->
        <p
            class="info-text"
            *ngIf="
                !esExcepcionTickeo &&
                !esAprobador &&
                data?.restricciones?.limite_dias != null &&
                data?.restricciones?.limite_dias < 365
            "
        >
            Solo puede seleccionar una fecha dentro de los últimos
            <strong>{{ data?.restricciones?.max_dias_plazo || 0 }}</strong>
            días.
        </p>

        <!-- Mensajes exclusivos para Excepción de Tickeo -->
        <p
            class="info-text"
            *ngIf="
                esExcepcionTickeo &&
                !esAprobador &&
                !esDetalle &&
                cargandoFechasTickeo
            "
        >
            Consultando las fechas habilitadas...
        </p>

        <p
            class="info-text"
            *ngIf="
                esExcepcionTickeo &&
                !esAprobador &&
                !esDetalle &&
                fechasTickeoCargadas &&
                !cargandoFechasTickeo &&
                errorFechasTickeo.length === 0
            "
        >

        <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Fecha de la excepción</mat-label>

                <input
                    matInput
                    [matDatepicker]="picker"
                    [(ngModel)]="fechaSalida"
                    [matDatepickerFilter]="filtroFechasValidas"
                    [min]="RangoMinFecha"
                    [max]="RangoMaxFecha"
                    [readonly]="true"
                    [disabled]="
                        esDetalle ||
                        (
                            esExcepcionTickeo &&
                            !esAprobador &&
                            (
                                cargandoFechasTickeo ||
                                !fechasTickeoCargadas
                            )
                        )
                    "
                    placeholder="Selecciona la fecha"
                    required
                />

                <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                    [disabled]="
                        esDetalle ||
                        (
                            esExcepcionTickeo &&
                            !esAprobador &&
                            (
                                cargandoFechasTickeo ||
                                !fechasTickeoCargadas
                            )
                        )
                    "
                >
                </mat-datepicker-toggle>

                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <mat-error
            *ngIf="
                esExcepcionTickeo &&
                !esAprobador &&
                errorFechasTickeo.length > 0
            "
            class="error-text"
        >
            {{ errorFechasTickeo }}
        </mat-error>

        <div class="form-row" style="margin-top: -10px;">
            <div class="form-group">
                <label for="horaInicio">Hora Inicio</label>

                <input
                    type="time"
                    id="horaInicio"
                    class="form-control"
                    [(ngModel)]="horaInicio"
                    [disabled]="esDetalle"
                    (change)="validateHoraRango()"
                />
            </div>

            <div class="form-group">
                <label for="horaFin">Hora Fin</label>

                <input
                    type="time"
                    id="horaFin"
                    class="form-control"
                    [(ngModel)]="horaFin"
                    [disabled]="esDetalle"
                    (change)="validateHoraRango()"
                />
            </div>
        </div>

        <mat-error *ngIf="horaRangoInvalido" class="error-text">
            La hora de inicio no puede ser mayor o igual que la hora fin.
        </mat-error>

        <mat-error *ngIf="fechaSalida && fechaFueraDeRango()">
            La fecha debe estar dentro de la gestión 2026.
        </mat-error>

        <div *ngIf="data?.detalle">
            <mat-form-field
                appearance="outline"
                class="form-field mt-3"
                style="width: 100%;"
            >
                <mat-label>Motivo de la solicitud</mat-label>

                <textarea
                    matInput
                    [(ngModel)]="descripcion"
                    maxlength="150"
                    minlength="5"
                    (input)="descripcion = descripcion.toUpperCase()"
                    [disabled]="esDetalle"
                    placeholder="Describe brevemente el motivo"
                    required
                ></textarea>

                <mat-hint align="end">
                    {{ descripcion.length }}/150
                </mat-hint>

                <mat-error *ngIf="descripcion.length < 5">
                    Debe tener al menos 5 caracteres.
                </mat-error>
            </mat-form-field>
        </div>

        <div *ngIf="
    estado === 'RECHAZADO' ||
    estado === 'DENEGADO' ||
    (estado === 'REVISION' && esAprobador)
">
    <mat-form-field
        appearance="outline"
        class="form-field mt-3 observacion-field"
        style="width: 100%;"
        subscriptSizing="dynamic"
    >
        <mat-label>Observación</mat-label>

        <textarea
            matInput
            [(ngModel)]="observacion"
            name="observacion"
            maxlength="150"
            minlength="5"
            (input)="observacion = observacion.toUpperCase()"
            placeholder="Describe brevemente el motivo"
            [disabled]="
                (estado === 'RECHAZADO' || estado === 'DENEGADO') &&
                !esAprobador
            "
            required
        ></textarea>

        <mat-hint align="end">
            {{ observacion.length }}/150
        </mat-hint>

        <mat-error
            *ngIf="
                (estado === 'RECHAZADO' || estado === 'DENEGADO') &&
                observacionInvalida()
            "
        >
            La observación es obligatoria y debe tener al menos 5 caracteres.
        </mat-error>

        <mat-error
            *ngIf="
                estado !== 'RECHAZADO' &&
                estado !== 'DENEGADO' &&
                observacion.length > 0 &&
                observacion.length < 5
            "
        >
            Debe tener al menos 5 caracteres.
        </mat-error>
    </mat-form-field>
</div>

    <div class="form-option" *ngIf="esAprobador">
        <mat-radio-group
            class="form-option"
            aria-label="SELECCIONAR UNA OPCIÓN:"
            [(ngModel)]="estado"
            name="estado"
            required
        >
            <mat-radio-button
                [value]="estadoAprobador"
                tabindex="-1"
            >
                APROBAR
            </mat-radio-button>

            <mat-radio-button
                value="DENEGADO"
                tabindex="-1"
            >
                DENEGAR
            </mat-radio-button>
        </mat-radio-group>

        <mat-error *ngIf="!estado">
            Debe seleccionar una opción de estado.
        </mat-error>
    </div>

    <div class="acciones">
        <button
            mat-raised-button
            color="primary"
            (click)="enviarExcepcion()"
            [disabled]="
                !fechaSalida ||
                !horaInicio ||
                !horaFin ||
                horaRangoInvalido ||
                (
                    data?.detalle &&
                    (!descripcion || descripcion.length < 5)
                ) ||
                fechaFueraDeRango() ||
                observacionInvalida() ||
                (
                    esExcepcionTickeo &&
                    !esAprobador &&
                    (
                        cargandoFechasTickeo ||
                        !fechasTickeoCargadas ||
                        errorFechasTickeo.length > 0 ||
                        (
                            fechaSalida != null &&
                            !filtroFechasValidas(fechaSalida)
                        )
                    )
                )
            "
            *ngIf="esVista"
        >
            {{
                esDetalle
                    ? 'Responder'
                    : modoEdicion === true
                        ? 'Modificar'
                        : 'Enviar'
            }}
            Solicitud
        </button>

        <button
            mat-raised-button
            color="warn"
            (click)="salir()"
        >
            {{ esVista ? 'Cancelar' : 'Cerrar' }}
        </button>
    </div>
</div>